import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { AppDispatch, logout } from '../../redux/internal';
import { SliceCallState } from '../../redux/sliceCallState';

import { RootState } from '../../redux/store';

export const PermissionsGate = ({ children }: { children: JSX.Element }) => {
  const { token, decodedToken, loading } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (decodedToken && decodedToken.exp && decodedToken.exp < Date.now() / 1000) {
      void dispatch(logout());
    }
  }, [decodedToken, dispatch]);

  useEffect(() => {
    if (!token && loading !== SliceCallState.pending) {
      navigate('/login');
    }
  }, [loading, navigate, token]);

  return children;
};
